/**
 * card-swipe.js — Sam's Store UAE  v4
 * Product card image carousel
 *   Mobile  : finger touch swipe + dots
 *   Desktop : hover arrows + click-drag / mouse swipe + dots on hover
 * Zero external libraries. ~4KB.
 */

(function () {
    'use strict';

    var SWIPE_THRESHOLD = 35; // px

    /* ── JSON helper ─────────────────────────────── */
    function getData(el) {
        try { return JSON.parse(el.dataset.images || '[]'); } catch (e) { return []; }
    }

    /* ── Build a carousel image ───────────────────── */
    function buildImg(src) {
        var img = document.createElement('img');
        img.className = 'card-swipe__img';
        img.src = src;
        img.alt = '';
        img.loading = 'eager';    /* No lazy — eliminates white flash on first swipe */
        img.decoding = 'async';
        img.draggable = false; // prevent browser native drag interfering with swipe
        return img;
    }

    /* ── Preload all images in a track upfront ────── */
    function preloadImages(urls) {
        urls.forEach(function (url) {
            var p = new Image();
            p.src = url;
        });
    }

    /* ── Build dots ──────────────────────────────── */
    function buildDots(count, track, container) {
        var wrap = document.createElement('div');
        wrap.className = 'card-swipe__dots';
        for (var i = 0; i < count; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'card-swipe__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Image ' + (i + 1));
            (function (idx) {
                dot.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    goTo(track, container, idx);
                });
            })(i);
            wrap.appendChild(dot);
        }
        return wrap;
    }

    /* ── Build arrow button ───────────────────────── */
    function buildArrow(dir, track, container) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'card-swipe__arrow card-swipe__arrow--' + dir;
        btn.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        btn.innerHTML = dir === 'prev'
            ? '<svg viewBox="0 0 16 16" fill="none"><path d="M10 13L5 8l5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            : '<svg viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var cur = Number(track.dataset.current || 0);
            var tot = Number(track.dataset.total || 1);
            goTo(track, container, dir === 'prev' ? (cur - 1 + tot) % tot : (cur + 1) % tot);
        });
        return btn;
    }

    /* ── Navigate to a slide ────────────────────── */
    function goTo(track, container, idx) {
        var slides = track.querySelectorAll('.card-swipe__img');
        var dots = container.querySelectorAll('.card-swipe__dot');

        // Load the TARGET slide's real image immediately (before showing it) to avoid white flash
        var targetSlide = slides[idx];
        if (targetSlide && targetSlide.dataset.lazySrc) {
            targetSlide.src = targetSlide.dataset.lazySrc;
            delete targetSlide.dataset.lazySrc;
        }

        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('is-active', i === idx); });
        track.dataset.current = idx;

        // Also preload adjacent slides
        [idx - 1, idx + 1].forEach(function (n) {
            var mod = ((n % slides.length) + slides.length) % slides.length;
            var el = slides[mod];
            if (el && el.dataset.lazySrc) { el.src = el.dataset.lazySrc; delete el.dataset.lazySrc; }
        });
    }

    /* ── Touch swipe (mobile + tablet finger) ─────── */
    function addTouchSwipe(track, container) {
        var startX, startY, moved;

        track.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            moved = false;
        }, { passive: true });

        track.addEventListener('touchmove', function () { moved = true; }, { passive: true });

        track.addEventListener('touchend', function (e) {
            if (!moved) return;
            var dx = e.changedTouches[0].clientX - startX;
            var dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
            var cur = Number(track.dataset.current || 0);
            var tot = Number(track.dataset.total || 1);
            goTo(track, container, dx < 0 ? (cur + 1) % tot : (cur - 1 + tot) % tot);
        }, { passive: true });
    }

    /* ── Mouse drag swipe (desktop/laptop magic trackpad) ─ */
    function addMouseSwipe(track, container) {
        var startX, dragging = false, hasDragged = false;

        track.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return; // left button only
            startX = e.clientX;
            dragging = true;
            hasDragged = false;
            track.style.cursor = 'grabbing';
        });

        document.addEventListener('mousemove', function (e) {
            if (!dragging) return;
            if (Math.abs(e.clientX - startX) > 5) hasDragged = true;
        });

        document.addEventListener('mouseup', function (e) {
            if (!dragging) return;
            dragging = false;
            track.style.cursor = 'grab';

            if (!hasDragged) return;
            var dx = e.clientX - startX;
            if (Math.abs(dx) < SWIPE_THRESHOLD) return;
            var cur = Number(track.dataset.current || 0);
            var tot = Number(track.dataset.total || 1);
            goTo(track, container, dx < 0 ? (cur + 1) % tot : (cur - 1 + tot) % tot);
        });

        // Prevent click on links/cards after drag
        track.addEventListener('click', function (e) {
            if (hasDragged) { e.preventDefault(); e.stopPropagation(); hasDragged = false; }
        }, true);

        track.style.cursor = 'grab';
    }

    /* ── Main: enhance one card ────────────────── */
    function enhance(mediaDiv) {
        if (mediaDiv.dataset.swiped) return;
        mediaDiv.dataset.swiped = '1';

        var images = getData(mediaDiv);
        if (!images || images.length < 2) return;

        var innerMedia = mediaDiv.querySelector('.media');
        if (!innerMedia) return;

        var showArrows = document.documentElement.dataset.cardSwipeArrows !== 'false';

        // Build track
        var track = document.createElement('div');
        track.className = 'card-swipe__track';
        track.dataset.current = '0';
        track.dataset.total = images.length;

        images.forEach(function (url, i) {
            var img = buildImg(i === 0 ? url : 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=');
            if (i === 0) { img.loading = 'eager'; img.classList.add('is-active'); }
            else { img.dataset.lazySrc = url; }
            track.appendChild(img);
        });

        // Hide original Dawn images only after building our track
        innerMedia.querySelectorAll('img').forEach(function (img) {
            img.style.display = 'none';
            img.setAttribute('aria-hidden', 'true');
        });

        // NOTE: Do NOT change innerMedia.style.position — Dawn sets it to absolute for height
        innerMedia.appendChild(track);

        // Dots (always — desktop dots show on hover via CSS)
        var dots = buildDots(images.length, track, innerMedia);
        innerMedia.appendChild(dots);

        // Arrows (desktop only — hidden on mobile via CSS media query)
        if (showArrows) {
            innerMedia.appendChild(buildArrow('prev', track, innerMedia));
            innerMedia.appendChild(buildArrow('next', track, innerMedia));
        }

        // Touch swipe (mobile / tablet)
        addTouchSwipe(track, innerMedia);

        // Mouse drag swipe (desktop laptop)
        addMouseSwipe(track, innerMedia);
    }

    /* ── Scan all cards on page ─────────────────── */
    function scanCards() {
        if (document.documentElement.dataset.cardSwipeEnabled === 'false') return;
        document.querySelectorAll('.card__media[data-images]').forEach(enhance);
    }

    /* ── Init ────────────────────────────────────── */
    function init() {
        scanCards();

        // Watch for dynamically added cards (infinite scroll, quick-view, etc.)
        if (window.MutationObserver) {
            new MutationObserver(function (mutations) {
                var needScan = false;
                mutations.forEach(function (m) {
                    if (needScan) return;
                    m.addedNodes.forEach(function (node) {
                        if (node.nodeType === 1 && node.querySelectorAll('.card__media[data-images]').length > 0) {
                            needScan = true;
                        }
                    });
                });
                if (needScan) setTimeout(scanCards, 80);
            }).observe(document.body, { childList: true, subtree: true });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
